import React from 'react';
import { Grid, Link, Typography, Box } from '@mui/material';
import styles from './BannerStyles';
import './BannerComponent.scss';

const BannerComponent = ({
  bannerType,
  continueAction
}) => {
  const bannerStyles = styles;
  const selectedBanner = bannerStyles[bannerType];
  const getLinkClass = (type) => {
    switch (type) {
      case 'info':
        return 'info-link';
      case 'warning':
        return 'warning-link';
      case 'success':
        return 'success-link';
      case 'error':
        return 'error-link';
      default:
        return '';
    }
  };
 const linkClass = getLinkClass(selectedBanner?.bannerType?.type);

  // display nothing if empty or false.
  if (!bannerType || !selectedBanner) {
    return null;
  }

  return (
    <Grid className='banner-box' container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <div
          className='banner'
          style={{ backgroundColor: selectedBanner.bannerType.backgroundColor }}
        >
          <img className='banner-icon' src={selectedBanner.bannerType.icon} alt='banner' />
          <Box className='banner-box-content'>
            <Typography className='banner-box-message'>{selectedBanner.message}</Typography>
            {selectedBanner.linkText !== undefined && (
              <Link className={`banner-box-link ${linkClass}`} style={{ color: selectedBanner.bannerType.linkColor }} onClick={() => continueAction(selectedBanner.linkText)}>
                {selectedBanner.linkText}
              </Link>
            )}
          </Box>
        </div>
      </Grid>
    </Grid>
  );
};

export default BannerComponent;
